/**
 * Floating Install prompt — DEPRECATED.
 *
 * Was a fixed-bottom card that blocked mobile scrolling and pushed the
 * landing page off-screen on narrow viewports. The Install button now
 * lives in the public top bar (`<PublicTopBar />`) via the shared
 * `usePwaInstall()` hook.
 *
 * This file is kept (rendering null) so any imports that haven't been
 * cleaned up yet keep compiling. Safe to delete once all references are
 * removed; doing it lazily so we don't blast the App.js routing tree in
 * the same diff that's also touching auth.
 */
export default function InstallPrompt() {
  return null;
}
